(function () {
  var ROOT_SELECTOR = '[data-sa-mobile-cro-pilot]';

  function syncSort(select) {
    var root = select.closest(ROOT_SELECTOR);
    var nativeSort = root && root.querySelector('#SortBy-mobile');
    var form = root && root.querySelector('#FacetFiltersFormMobile');
    if (!nativeSort || !form || nativeSort.value === select.value) return;
    nativeSort.value = select.value;
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function updateRailProgress(rail, indicator) {
    var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var progress = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
    indicator.style.setProperty('--sa-mobile-rail-progress', String(progress));
  }

  function initRail(root) {
    var rail = root.querySelector('[data-sa-preset-cards]');
    if (!rail || rail.dataset.saMobileCroReady === 'true') return;
    rail.dataset.saMobileCroReady = 'true';

    var indicator = document.createElement('div');
    indicator.className = 'sa-mobile-cro-rail-progress';
    indicator.setAttribute('aria-hidden', 'true');
    root.querySelector('.sa-ai-preset__body').appendChild(indicator);
    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { updateRailProgress(rail, indicator); });
    }, { passive: true });

    var observer = new MutationObserver(function () {
      rail.scrollLeft = 0;
      updateRailProgress(rail, indicator);
    });
    observer.observe(rail, { childList: true });
    updateRailProgress(rail, indicator);
  }

  function init() {
    var collectionRoot = document.querySelector(ROOT_SELECTOR);
    if (!collectionRoot) return;
    document.querySelectorAll('[data-sa-ai-preset]').forEach(initRail);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sa-mobile-cro-sort]');
    if (select) syncSort(select);
  });
  document.addEventListener('sa:collection-grid:rendered', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
